export const queryKeys = {
  TG_CHATBOT: 'TG_CHATBOT',
  PATCH_TG_CHATBOT_USERS: 'PATCH_TG_CHATBOT_USERS',
  DELETE_TG_CHATBOT_USER: 'DELETE_TG_CHATBOT_USER',
  GET_TG_CHATBOT_URL: 'GET_TG_CHATBOT_URL',
  GET_EMPLOYEES: 'GET_EMPLOYEES'
};
